// فهرستِ «کسانی که با ایمیل دعوت می‌شن»، قبل از اینکه سیگنال اصلاً ساخته شه.
//
// منطقِ خالص و بی‌ایمپورت، چون هر دو اپ همین رفتار را می‌خواهند و دو بار
// نوشتنش یعنی دو رفتارِ کمی متفاوت. سرور همین قاعده‌ها را دوباره دارد
// (`invite_by_email` در مایگریشن 0066) — این‌جا فقط برای اینه که کاربر
// **قبل از** فرستادن بفهمد، نه بعدش.
import { normalizeEmail } from './contacts.ts';

export interface DraftInvitee {
  /** همیشه نرمال‌شده: بدون فاصله و با حروفِ کوچک. */
  email: string;
  name: string | null;
}

export type AddResult =
  | { ok: true; list: DraftInvitee[] }
  | { ok: false; reason: 'invalid' | 'duplicate' | 'full' };

/**
 * سقفِ هر سیگنال. همان عددی که `invite_by_email` هم دارد — و باید همان بماند،
 * وگرنه کاربر بیست‌تا اضافه می‌کند و سرور بی‌توضیح ردشان می‌کند.
 */
export const MAX_EMAIL_INVITES = 50;

/**
 * یک نفر را به فهرست اضافه می‌کند.
 *
 * سه دلیلِ ردشدن از هم جدا برمی‌گردند چون پیامِ هرکدام فرق دارد: «ایمیل
 * نیست»، «قبلاً اضافه‌ش کردی»، «به سقف خوردی». یک `false` برای هر سه یعنی
 * کاربر نمی‌فهمد کدامش بوده.
 */
export function addInvitee(
  list: readonly DraftInvitee[], rawEmail: string, rawName?: string,
): AddResult {
  const email = normalizeEmail(rawEmail);
  if (!email) return { ok: false, reason: 'invalid' };
  if (list.some((i) => i.email === email)) return { ok: false, reason: 'duplicate' };
  if (list.length >= MAX_EMAIL_INVITES) return { ok: false, reason: 'full' };

  const name = (rawName ?? '').trim();
  return { ok: true, list: [...list, { email, name: name || null }] };
}

export const removeInvitee = (
  list: readonly DraftInvitee[], email: string,
): DraftInvitee[] => list.filter((i) => i.email !== email);

/** آنچه روی چیپ نوشته می‌شود: اسم اگر بود، وگرنه خودِ آدرس. */
export const inviteeLabel = (i: DraftInvitee): string => i.name || i.email;
